import styled from 'styled-components';

export const BlockMobileMainWrap = styled.div(
    props => `
        width:100%;
        height: 80vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.large.l30};
    `
);

export const BlockMobileInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `
);

export const ImageWrap = styled.div(
    props => `
        width:20rem;
        height: 20rem;
        margin-bottom: ${props.theme.spacing.large.l20};
    `
);

export const HeadingWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: ${props.theme.spacing.small.s5}
    `
);

export const HeadingText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-align: center;
    `
);

export const SubHeadTextWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: ${props.theme.spacing.base}
    `
);

export const SubHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        text-align: center;
    `
);